import React, { memo } from "react";
import { ReactSVG } from "react-svg";

import { classNames, useCardSize } from "helpers";
import { GridWidgetProps } from "./types";

/**
 * Jedan widget u mreži. Mjeri vlastitu širinu i objavljuje je kroz `data-size`,
 * pa sadržaj može stisnuti tipografiju kad je kartica uska — bez obzira na širinu ekrana.
 */
const GridWidget: React.FC<GridWidgetProps> = (props: GridWidgetProps) => {
  const { widget, isVisible, registerRef } = props;

  const { size, ref } = useCardSize<HTMLDivElement>();

  return (
    <div
      ref={registerRef}
      className={classNames(
        "h-full w-full bg-white rounded-[5px] transition-all duration-500 ease-out flex flex-col",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      )}
    >
      {/* Header (drag handle) */}
      <div className="flex items-center justify-between gap-2 py-3 px-4 flex-shrink-0">
        <div className="flex items-center gap-2 min-w-0">
          <h2
            data-size={size}
            className="text-lg font-medium text-slate-900 truncate data-[size=sm]:text-sm data-[size=md]:text-base"
          >
            {widget.title}
          </h2>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <div className="no-drag">{widget.header}</div>
          <span className="drag-handle cursor-move hover:bg-slate-50">
            <ReactSVG
              src={`/media/icons/drag-and-drop.svg`}
              className="w-5 h-5 stroke-blue-500"
            />
          </span>
        </div>
      </div>

      {/* Content — montira se tek kad widget uđe u viewport (lazy load + animacija tada). */}
      <div
        ref={ref}
        data-size={size}
        className="group/dashcard overflow-y-auto overflow-x-hidden flex-1 min-h-0"
      >
        {isVisible ? widget.content : null}
      </div>
    </div>
  );
};

export default memo(GridWidget);
